import { useEffect, useState } from 'react';
import LogoBriefForm from '../Components/LogoBriefForm/LogoBriefForm';
import arLang from '../languages/arabic.json';
import heLang from '../languages/hebrew.json';

const LOCALES = {
    ar: {
        copy: arLang.logoBrief,
        font: 'ar',
        dir: 'rtl',
        txtAlign: 'right',
    },
    he: {
        copy: heLang.logoBrief,
        font: 'he',
        dir: 'rtl',
        txtAlign: 'right',
    },
};

const LogoFormPage = () => {
    const [locale, setLocale] = useState(() => {
        const saved = sessionStorage.getItem('logo-form-locale');
        return saved === 'he' ? 'he' : 'ar';
    });

    useEffect(() => {
        sessionStorage.setItem('logo-form-locale', locale);
    }, [locale]);

    const active = LOCALES[locale];
    const switchLabel =
        locale === 'ar'
            ? heLang.logoBrief.languageSwitch
            : arLang.logoBrief.languageSwitch;

    const toggleLocale = () => {
        setLocale((prev) => (prev === 'ar' ? 'he' : 'ar'));
    };

    return (
        <LogoBriefForm
            copy={active.copy}
            font={active.font}
            dir={active.dir}
            txtAlign={active.txtAlign}
            locale={locale}
            switchLabel={switchLabel}
            onLocaleSwitch={toggleLocale}
        />
    );
};

export { LogoFormPage };
export default LogoFormPage;
